import React, { Component } from 'react';
import $ from 'jquery';

class EditCutInventoryModal extends Component {

    openAction = () => {
        $('#EditCutInventoryModal').on('hide.bs.modal', function () { });
    };

    closeModalCreate = async () => {
        const { closeModal } = this.props;

        $('#EditCutInventoryModal').modal('hide');
        await closeModal();
    };

    renderHeader = () => {
        const { newOrderModelCutInventory, changeReference2 } = this.props;

        return (
            <div className="row">
                <div className="col-sm-8">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            {/*No Serie*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de recuento</span>
                                </div>
                                <input
                                    type="date"
                                    className=" form-control"
                                    id="txtDocumentDate"
                                    disabled
                                    value={newOrderModelCutInventory.CountDate ? newOrderModelCutInventory.CountDate : ''}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Hora</span>
                                </div>
                                <input
                                    type="hour"
                                    className=" form-control"
                                    id="txtNo"
                                    disabled
                                    value={newOrderModelCutInventory.Time ? newOrderModelCutInventory.Time : ''}
                                />
                            </div>
                        </div>
                    </div>

                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de recuento</span>
                        </div>
                        <select
                            type="text"
                            className="form-control"
                            id="txtName"
                            disabled
                            value={newOrderModelCutInventory.CountType ? newOrderModelCutInventory.CountType : ''}>

                            <option value="1">Encargado de recuento simple</option>
                            <option value="2">Encargados de recuento múltiples</option>
                        </select>
                    </div> */}

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Encargado de recuento de inventario</span>
                        </div>
                        <select
                            type="select"
                            className=" form-control"
                            id="sltType"
                            disabled
                            value={newOrderModelCutInventory.Taker1Type ? newOrderModelCutInventory.Taker1Type : ''}>

                            <option value="User">Usuario</option>
                            <option value="Vendor">Proveedor</option>
                        </select>
                        <input
                            type="text"
                            className=" form-control"
                            id="sltName"
                            disabled
                            value={newOrderModelCutInventory.TakerName ? newOrderModelCutInventory.TakerName : ''}
                        />
                    </div>
                </div>

                {/*Segunda columna*/}
                <div className="col-sm-4">
                    <div className="row">
                        <div className="col-12 col-lg-6">
                            {/*No Serie*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtDocumentDate"
                                    disabled
                                    value={newOrderModelCutInventory.SeriesName ? newOrderModelCutInventory.SeriesName : ''}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            {/*N°:*/}
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                                </div>
                                <input
                                    type=" text"
                                    className=" form-control"
                                    id="txtNo"
                                    disabled
                                    value={newOrderModelCutInventory.NextNumber ? newOrderModelCutInventory.NextNumber : ''}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtStatus"
                            disabled
                            value={newOrderModelCutInventory.Status ? newOrderModelCutInventory.Status : ''}
                        />
                    </div> */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtStatus"
                            // disabled
                            value={newOrderModelCutInventory.Ref2 ? newOrderModelCutInventory.Ref2 : ''}
                            onChange={changeReference2}
                            maxLength={11}
                        />
                    </div>
                </div>
            </div>
        )
    };

    renderBody = () => {
        const {
            newOrderModelCutInventory,
            changeCountQtyItem
        } = this.props;

        return (
            <div style={{ marginBottom: 30 }}>
                <div className="tab-content">
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane active"
                        id="dataCutInventory"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}>

                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Número de artículo
                                    </td>
                                    <td className=" sticky-column sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 350, maxWidth: 800 }}>
                                        Descripción
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Almacén
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24', minWidth: 300 }}>
                                        Posición de ubicación
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cantidad en almacén <br />
                                        en fecha de recuento
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Cantidad <br />
                                        contada
                                    </td>
                                    <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                        Desviación
                                    </td>
                                    {/* Eliminar */}
                                    {/* <td
                                        className="sticky-header sticky-columns"
                                        style={{ backgroundColor: '#d2ab24' }}
                                    /> */}
                                </tr>
                            </thead>
                            <tbody>
                                {!!newOrderModelCutInventory.Items && newOrderModelCutInventory.Items.map((item, index) => {
                                    return (
                                        <tr style={{
                                            maxHeight: 10,
                                            paddingTop: 8,
                                            paddingBottom: 8
                                        }}
                                            key={'cutInventory' + index}
                                        >
                                            {/* Número de artículo */}
                                            <td className="sticky-column" style={{ textAlign: 'left', width: 500, backgroundColor: '#ffffff' }}>
                                                {item.ItemCode}
                                            </td>
                                            {/* Descripción */}
                                            <td className="overflow-visible" style={{ textAlign: 'left', maxWidth: 800 }}>
                                                {item.ItemDesc}
                                            </td>
                                            {/* Almacén */}
                                            <td className="overflow-visible" style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.WhsCode}
                                            </td>
                                            {/* Posición de ubicación */}
                                            <td className="overflow-visible" style={{ textAlign: 'left', maxWidth: 800 }}>
                                                {item.BinCode}
                                            </td>
                                            {/* Cantidad en almacén en fecha de recuento */}
                                            <td className="overflow-visible" style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {Number(item.InWhsQty).toFixed(4)}
                                            </td>
                                            {/* Cantidad contada */}
                                            <td className="overflow-visible" style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {/* {item.CountQty} */}
                                                <input
                                                    type="number"
                                                    className="form-control validarCant cantBlur btn-outline-secondary"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        borderColor: '#ced4da',
                                                        color: '#000',
                                                        paddingTop: 1,
                                                        paddingBottom: 2,
                                                        width: 100,
                                                        textAlign: "center",
                                                    }}
                                                    step="any"
                                                    id={'itemCantidad' + index}
                                                    value={item.CountQty}
                                                    onChange={event => changeCountQtyItem(event, index)}
                                                // onBlur={() => specialPrice(index)}
                                                />
                                            </td>
                                            {/* Desviación */}
                                            <td className="overflow-visible" style={{ textAlign: 'center', maxWidth: 800 }}>
                                                {item.Difference}
                                            </td>
                                            {/* Eliminar */}
                                            {/* Vamos a quitar el boton de eliminar lineas para que el usuario mande el recuento de todo lo que tiene en esa ubicación */}
                                            {/* <td
                                                className="sticky-columns"
                                                style={{
                                                    backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : '#FFF',
                                                    textAlign: 'center'
                                                }}>
                                                <button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        padding: 5,
                                                        color: '#c42222',
                                                        paddingTop: 2,
                                                        paddingBottom: 2,
                                                    }}
                                                    className="btn"
                                                    onClick={() => this.deleteService(index)}>
                                                    <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                </button>
                                            </td> */}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    };

    render() {
        const { newOrderModelCutInventory, sendInventoryCountings } = this.props;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="EditCutInventoryModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ zIndex: 90 }}>

                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Recuento de inventario
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderHeader()}
                                                {this.renderBody()}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">

                            <button type="button" className="btn botonCorrect" onClick={sendInventoryCountings}>
                                Enviar recuento
                            </button>

                            {/* {(action === 2 && view === 'deliveries' && itemBaseType.length > 0) &&
                                <button
                                    type="button"
                                    className="btn btn-danger text-white "
                                    style={{ position: "absolute", left: "1rem" }}
                                    onClick={this.OpenModalCloseDocuments}>
                                    Cancelar
                                </button>
                            }

                            {status === 1 && Number(action) === 2 && writeAccess && (view === 'orderSales' || view === 'deliveries') && !editMode && false && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(2)} >
                                    Facturar
                                </button>
                            )}

                            {Number(action) === 2 && writeAccess && view === 'invoiceBorrador' && !editMode && newOrderModel.isCreator !== 'Y' && (
                                <button type="button" className="btn botonCorrect" onClick={() => this.billingInfo(3)}>
                                    Crear
                                </button>
                            )}
                            {(view === 'invoiceBorrador' && newOrderModel.ObjType === "67" && newOrderModel.U_FMB_EditTraslado === 'N' && newOrderModel.SendRequestEdition === 'Y' && newOrderModel.isCreator === 'Y') &&
                                <button type="button" className="btn botonCorrect" onClick={() => SendAprovedPartial()}>
                                    Aprobar Edición Parcial
                                </button>
                            }
                            {Number(action) === 2 && writeAccess && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {Number(action) === 2 && writeAccess && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}*/}

                        </div>
                    </div>
                </div>
                {this.openAction()}
            </div>
        );
    }
}


export default EditCutInventoryModal;